import { createContext, useContext } from "react";

import type { ExportablesContextValue } from "./ExportablesContextProvider.types";

export const ExportablesContext = createContext<ExportablesContextValue | null>(
  null,
);

export const useExportablesContext = (): ExportablesContextValue => {
  const context = useContext(ExportablesContext);
  if (!context) {
    throw new Error(
      "Exportables compound components must be used within a Exportables context",
    );
  }
  return context;
};
